"use strict";

var currentTime = 0;
var nowTime = Date.now();
var isPlayed = false;
var newName = videoName.split(".mp4");
var videoType = "application/x-mpegURL";
newName = newName[0];

// $(document).keyup(function (e) {
//     if (e.keyCode === 27) {
//         if (player.isFullscreen()) {
//             player.exitFullscreen();
//         }
//     }
// });

// Init server video url
function initServer() {
  // Get server infomation from cookie
  var serverLocaltion = getCookie("server_localtion");

  if (serverLocaltion != null && serverLocaltion != "") {
    for (var i = 0; i < listServers.length; i++) {
      if (listServers[i].id == serverLocaltion) {
        return listServers[i].url;
      }
    }
  }

  // Default server url
  return listServers.length > 0 ? listServers[0].url : "";
}

// Init server video id
function initServerId() {
  // Get server infomation from cookie
  var serverLocaltion = getCookie("server_localtion");

  if (serverLocaltion != null && serverLocaltion != "") {
    for (var i = 0; i < listServers.length; i++) {
      if (listServers[i].id == serverLocaltion) {
        return listServers[i].id;
      }
    }
  }

  // Default server id
  return 1;
}

// Lấy ra chất lượng video
function initQuality() {
  var videoQuality = getCookie("video_quality");
  if (videoQuality != null && videoQuality != "") return videoQuality;

  return "720p";
}

// Get url by id
function findServerUrl(id) {
  for (var i = 0; i < listServers.length; i++) {
    if (listServers[i].id == id) {
      return listServers[i].url;
    }
  }
}

var videoPlayer = new Vue({
  el: ".cover-container",
  data: {
    currentserverId: initServerId(),
    currentServer: initServer(),
    listServers: listServers,
    currentQuality: initQuality(),
  },

  methods: {
    changeServerBySelectTag: function changeServerBySelectTag() {
      var vm = this;

      setCookie("server_localtion", vm.currentserverId, 30);

      var server = vm.currentServer;
      server = findServerUrl(vm.currentserverId);
      vm.currentServer = server;
      player.src({
        src: generateUrl(),
        type: videoType,
        withCredentials: false,
      });

      if (isPlayed) {
        player.play();
      }
    },

    // Chọn server khác
    changeServerLocaltion: function changeServerLocaltion(id) {
      var vm = this;

      // Đặt lại cookie cài đặt nhớ trong 30 ngày
      setCookie("server_localtion", id, 30);

      vm.currentserverId = id;
      var server = vm.currentServer;
      server = findServerUrl(id);
      vm.currentServer = server;
      currentTime = player.currentTime();
      player.src({
        src: generateUrl(),
        type: videoType,
        withCredentials: false,
      });

      if (isPlayed) {
        player.play();
      }
      setPlayContinue();
    },

    // Chọn chất lượng khác
    onChangeQuality: function onChangeQuality() {
      var vm = this;

      // Đặt lại cookie cài đặt nhớ trong 30 ngày
      setCookie("video_quality", vm.currentQuality, 30);
      currentTime = player.currentTime();
      player.src({
        src: generateUrl(),
        type: videoType,
        withCredentials: false,
      });
      if (isPlayed) {
        player.play();
      }
      setPlayContinue();
    },

    // tua lại
    fastRewind: function fastRewind() {
      player.currentTime(player.currentTime() - 10);
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        $(".left-fast-icon").fadeIn();
        $(".left-fast-icon").fadeOut();
      }
    },

    // tua đi
    fastForward: function fastForward() {
      player.currentTime(player.currentTime() + 10);
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        $(".right-fast-icon").fadeIn();
        $(".right-fast-icon").fadeOut();
      }
    },
  },

  mounted: function mounted() {
    var vm = this;

    // Display button select server on mobile
    var width = window.innerWidth > 0 ? window.innerWidth : screen.width;
    if (width <= 768) {
      $(".select-localtion-select").css("display", "block");
      $(".server-item").css("display", "none");
    }
  },
});

function setPlayContinue() {
  setTimeout(function () {
    player.currentTime(currentTime);
  }, 500);
}

var serverLocaltion = 1;
if (getCookie("server_localtion")) {
  serverLocaltion = getCookie("server_localtion");
} else {
  setCookie("server_localtion", 1, 30);
}

videojs.options.hls.overrideNative = true;
var options = {
  playbackRates: [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2],
  preload: "none",
  language: "ko",
  controlBar: {
    volumeMenuButton: {
      vertical: true,
      inline: false,
      volumeBar: {
        vertical: true,
      },
      volumeLevel: true,
    },
  },
  html5: {
    nativeAudioTracks: false,
    nativeVideoTracks: false,
  },
  flash: {
    swf: "//cdnjs.cloudflare.com/ajax/libs/videojs-swf/5.4.2/video-js.swf",
  },
  fluid: true,
};

var player = videojs("myplayer_" + playerId, options);
var serverLocaltion = 1;
if (getCookie("server_localtion")) {
  serverLocaltion = getCookie("server_localtion");
} else {
  setCookie("server_localtion", 1, 30);
}

// Không cho click chuột phải
player.on("contextmenu", function (e) {
  e.preventDefault();
});

jQuery("video").on("touchstart", function () {
  if (player.paused()) {
    player.play();
  } else {
    player.pause();
  }
});
jQuery("video").on("pause", function () {
  togglePlayPauseButton();
});

jQuery("video").on("play", function () {
  togglePlayPauseButton("play");
});

$("#myplayer_" + playerId).prepend(
  '<div class="ytp-bezel play" id="yt-play-button" style="display: none;">\n' +
    '                                <div class="ytp-bezel-icon">\n' +
    '                                    <svg height="100%" version="1.1" viewBox="0 0 36 36" width="100%"><use class="ytp-svg-shadow"></use>\n' +
    '                                        <path class="ytp-svg-fill play" d="M 12,26 18.5,22 18.5,14 12,10 z M 18.5,22 25,18 25,18 18.5,14 z"></path>\n' +
    '                                        <path class="ytp-svg-fill pause" style="display: none;" d="M 12,26 16,26 16,10 12,10 z M 21,26 25,26 25,10 21,10 z"></path>\n' +
    "                                    </svg>\n" +
    "                                </div>\n" +
    "                            </div>"
);

$("#myplayer_" + playerId).prepend(`
<div class="rewind-forward" style="display: none">
    <div class="fast-area fast-left"><i class="zmdi zmdi-fast-rewind left-fast-icon"></i></div>
    <div class="fast-area fast-right"><i class="zmdi zmdi-fast-forward right-fast-icon"></i></div>
</div>
`);

$(document).on("click", ".fast-left", function () {
  videoPlayer.fastRewind();
});

$(document).on("click", ".fast-right", function () {
  videoPlayer.fastForward();
});

var togglePlayPauseButton = function togglePlayPauseButton(action) {
  if (action == "play") {
    $("#yt-play-button").addClass("play");
  } else {
    $("#yt-play-button").removeClass("play");
  }
  $(".ytp-bezel").fadeIn();
  $(".ytp-bezel").fadeOut();
  if ($("#yt-play-button").hasClass("play")) {
    $("path.play").show();
    $("path.pause").hide();
  } else {
    $("path.play").hide();
    $("path.pause").show();
  }
  $("#yt-play-button").toggleClass("play");
};

var generateUrl = function generateUrl() {
  videoType = "application/x-mpegURL";
  return (
    videoPlayer.currentServer +
    "/" +
    newName +
    "/" +
    newName +
    "-" +
    videoPlayer.currentQuality +
    ".m3u8?ver=" +
    nowTime
  );
};

// Gắn luồng dữ liệu vào để chạy video hls

function setCookieVideo(courseId, lessonId, time) {
  setCookie("video-play-" + courseId + "-" + lessonId, time);
}

function getCookieVideo(courseId, lessonId) {
  return getCookie("video-play-" + courseId + "-" + lessonId);
}
var courseId = typeof lesson_course !== "undefined" ? lesson_course.id : "";
var lessonId =
  typeof lesson_lessonDetail !== "undefined" ? lesson_lessonDetail.id : "";
currentTime = getCookieVideo(courseId, lessonId);
player.on("timeupdate", function () {
  currentTime = this.currentTime();
  setCookieVideo(courseId, lessonId, currentTime);
});

player.src({
  src: generateUrl(),
  type: videoType,
  withCredentials: false,
});

// Sự kiện click vào chạy video
$(".movie-play").click(function () {
  isPlayed = true;
  $(".movie-play").css("display", "none");
  $("#myplayer_" + playerId).css("display", "block");
  $(".rewind-forward").show();
  player.currentTime(currentTime);
  player.play();
});

var body = document.getElementsByTagName("body")[0];
body.addEventListener("keydown", function (e) {
  if (!player) return;
  if (e.path[0].id === "comment-content" || e.path[0].tagName === "TEXTAREA")
    return;
  if (e.keyCode === 37) {
    player.currentTime(player.currentTime() - 5);
  } else if (e.keyCode === 39) {
    player.currentTime(player.currentTime() + 5);
  } else if (e.keyCode === 32) {
    e.preventDefault();
    if (player.paused()) {
      player.play();
    } else {
      player.pause();
    }
  }
});

/**
 * detect IE
 * returns version of IE or false, if browser is not Internet Explorer
 */
function detectIE() {
  var ua = window.navigator.userAgent;

  // Test values; Uncomment to check result …

  // IE 10
  // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

  // IE 11
  // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

  // Edge 12 (Spartan)
  // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

  // Edge 13
  // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

  var msie = ua.indexOf("MSIE ");
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)), 10);
  }

  var trident = ua.indexOf("Trident/");
  if (trident > 0) {
    // IE 11 => return version number
    var rv = ua.indexOf("rv:");
    return parseInt(ua.substring(rv + 3, ua.indexOf(".", rv)), 10);
  }

  var edge = ua.indexOf("Edge/");
  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf(".", edge)), 10);
  }
  // other browser
  return false;
}

$(".fancybox").fancybox();
